// test2771
(2771 && 0);
